<div class=" orderSummaryPage">
  <div class="row">
    <div class="col-md-10">
      <h3>Total Order Summary</h3>
      <p class="itemAvailText smalltext" *ngIf="isProductSearch">
        Filter the results below by selecting for the filter type to see the order summary for this crop year.  Drill down by clicking the links to see more detailed reports that retain your filter criteria.
      </p>
      <p class="itemAvailText smalltext" *ngIf="showProductLineDetail">
        Filter the results below by selecting for the filter type to see the order summary for this crop year.  Drill down by clicking the links to see more detailed reports that retain your filter criteria.
      </p>
      <p class="itemAvailText smalltext" *ngIf="showProductDetail">
        Filter the results below by selecting for the filter type to see the order summary for this crop year.
      </p>
    </div>
    <div class="col-md-2 text-right m-auto">
      <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
      <a href="Javascript:void(0);" style="color: #0b3f54; padding:15px;" (click)="selectFilter()">MANAGE REPORTS</a>
    </div>
  </div>
  <!--region for product search-->
  <div class="row margin-r0 margin-t15 margin-l0 quickSearchTopFilter">
    <div class="col-sm-7 col-md-9 col-lg-10 smallPadRgt0 padding-l0">
      <div class="row search-box-outer">
        <div class="col-md-3 col-lg-3 padding-r0 borderRight padding-l0">
          <div class="category-dropdown material-select">
            <ng-select [items]="searchTypeList"
                       name="ddlProductSearch"
                       [(ngModel)]="selectedValue"
                       [virtualScroll]="true"
                       [closeOnSelect]="true"
                       [selectOnTab]="true"
                       [clearable]="false"
                       bindValue="value"
                       labelForId="name"
                       [searchable]="false"
                       (change)="keepFilter(null, ' ')">
            </ng-select>
          </div>
        </div>
        <div class="col-md-9 col-lg-9 padding-l0 padding-r0">
          <div class="material-select reports-search-filter">
            <ng-select #ProductLine *ngIf="selectedValue === 'Product Line'"
                       [items]="productLineMasterList"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="true"
                       [hideSelected]="true"
                       [(ngModel)]="filterList.ProductLineList"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(ProductLine,'ProductLine')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <ng-select #MarketingBrand *ngIf="selectedValue === 'Marketing Brand'"
                       [items]="marketingMasterList"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="true"
                       [hideSelected]="true"
                       [(ngModel)]="filterList.MarketingBrandList"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(MarketingBrand,'MarketingBrand')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <ng-select #AccountNo *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == true"
                       [items]="accountNoList"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="true"
                       [hideSelected]="true"
                       [(ngModel)]="filterList.AccountNo"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="keepFilter(AccountNo,'AccountNo')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <div #productSearch *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == false">
              <div class="search-box-outer margin-l10">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="filterList.TxtAccountNo"
                           placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                  </div>
                </div>
              </div>
            </div>
            <div #productSearch *ngIf="selectedValue === 'Account Name'">
              <div class="search-box-outer margin-l10">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="filterList.AccountName"
                           placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>
            <ng-select #District *ngIf="selectedValue === 'WFU Employee'"
                       [items]="districtMasterList"
                       placeholder="Search..."
                       [multiple]="true"
                       [hideSelected]="true"
                       class="custom-select-grower"
                       [(ngModel)]="filterList.DistrictList"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(null, ' ')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <div #productSearch *ngIf="selectedValue === 'City'">
              <div class="search-box-outer margin-l10">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="filterList.City"
                           placeholder="Search..." type="text" pattern="^[a-zA-Z0-9,]+$" #cityCtrl>
                  </div>
                </div>
              </div>
            </div>
            <ng-select #State *ngIf="selectedValue === 'State/Province'"
                       [items]="stateMasterList"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="true"
                       [hideSelected]="true"
                       [(ngModel)]="filterList.State"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(State,'State')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <div #productSearch *ngIf="selectedValue === 'Product Name' && (showProductLineDetail || showProductDetail)">
              <div class="search-box-outer margin-l10">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="filterList.Brand"
                           placeholder="Search..." type="text">
                  </div>
                </div>
              </div>
            </div>

            <div #productSearch *ngIf="selectedValue === 'Order No' && showProductDetail">
              <div class="search-box-outer margin-l10">
                <div class="search-box wide100">
                  <span class="search-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <div class="select-container">
                    <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="filterList.OrderId"
                           placeholder="Search..." type="text" pattern="^[a-zA-Z0-9,]+$" #orderIdCtrl>
                  </div>
                </div>
              </div>
            </div>
            <ng-select #OrderType *ngIf="selectedValue === 'Order Type' && showProductDetail"
                       [items]="orderTypeList"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="false"
                       [hideSelected]="true"
                       [(ngModel)]="filterList.OrderTypeList"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(OrderType,'OrderType')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <ng-select #PackageSize *ngIf="selectedValue === 'Package Size' && showProductDetail"
                       [items]="packagesizeMasterList"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="true"
                       [hideSelected]="true"
                       [(ngModel)]="filterList.PackageSizeList"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(PackageSize,'PackageSize')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <ng-select #Seedsize *ngIf="selectedValue === 'Seed Size' && showProductDetail"
                       [items]="seedsizeMasterList"
                       placeholder="Search..."
                       [multiple]="true"
                       [hideSelected]="true"
                       class="custom-select-grower"
                       [(ngModel)]="filterList.SeedSizeList"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(Seedsize,'Seedsize')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
            <ng-select #Treatment *ngIf="selectedValue === 'Treatment' && showProductDetail"
                       [items]="treatmentMasterList"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="true"
                       [hideSelected]="true"
                       [(ngModel)]="filterList.TreatmentList"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFun"
                       (change)="keepFilter(Treatment,'Treatment')">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-5 col-md-3 col-lg-2 search-btn-outer text-right padding-l20 padding-r0">
      <div class="row">
        <div class="col-sm-6 padding-r5">
          <div class="search-btn">
            <button mat-raised-button class="btns" color="primary" (click)="keepFilter(null, ' ');getTotalOrderSummary();">Search</button>
          </div>
        </div>
        <div class="col-sm-6 padding-l5">
          <div class="search-btn">
            <button mat-raised-button class="btns" color="primary" (click)="exportResult()"
                    [disabled]="((isProductSearch && totalOrderSummaryDataSource?.data.length <= 0) || (showProductLineDetail && productTotalOrderSummaryDataSource?.data.length <= 0) || (showProductDetail && productDetailDS?.length <= 0))">
              Export
            </button>
          </div>
        </div>
      </div>
      <!--<div class="search-btn">
        <button mat-raised-button class="btns" color="primary" (click)="keepFilter(null, ' ');getTotalOrderSummary();">Search</button>
        <button mat-raised-button class="btns" color="primary"
                [disabled]="((isProductSearch && totalOrderSummaryDataSource?.data.length <= 0) || (showProductLineDetail && productTotalOrderSummaryDataSource?.data.length <= 0) || (showProductDetail && productDetailDS?.length <= 0))">
          Export Results
        </button>
      </div>-->
    </div>
    <div class="col-md-12">
      <div class="chips-sec">
        <div class="row selected-chip">
          <div class="col-sm-9 col-md-10 padding-l0">
            <div>
              <mat-chip-set>
                <mat-chip selected *ngFor="let filterValue of filterValueList">
                  {{filterValue}}
                  <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                    <i class="fas fa-times text-right"></i>
                  </a>
                </mat-chip>
              </mat-chip-set>
            </div>
          </div>
          <div class="col-sm-3 col-md-2 text-right padding-r0" *ngIf="filterValueList.length > 0">
            <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 padding-l30 padding-r0 padding-b10 padding-t10">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-9 padding-r30 padding-l0 text-left">
              <div class="row">
                <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                  <p *ngIf="currentFilter.filterDescription">REPORT NAME: {{currentFilter.filterDescription}}</p>
                </div>
                <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                  <p *ngIf="currentFilter.filterDescription">
                    LAST RUN DATE: {{(currentFilter.lastRunByTimeStamp || currentFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                  </p>
                </div>
                <div class="col-sm-3 col-md-3 padding-r30">
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="editFilter()" *ngIf="(currentFilter.userReportFilterId || !(currentFilter.userReportFilterId)) && currentFilter.filterDescription">Edit Report</button>
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="save()" *ngIf="currentFilter.filterDescription">Save</button>
                </div>
              </div>
            </div>
            <div class="col-sm-3 col-md-3 text-right">
              <div class="padding-r0 ">
                <button mat-raised-button class="btns" color="primary" (click)="addFilter()">Create Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row breadcrumbRow ">
    <div class="col-md-4">
      <p class="searchText">
        Search Result:
      </p>
    </div>
    <div class="col-md-8 text-right">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb search-breadcrumb">
          <li *ngIf="isProductSearch || showProductLineDetail || showProductDetail" [ngClass]="isProductSearch == true ? 'breadcrumb-item active' : 'breadcrumb-item'">
            <a *ngIf="isProductSearch == false" href="javascript:void(0)" (click)="revertToIsProductSearch()">Total Order Summary</a>
            <span *ngIf="isProductSearch == true">Total Order Summary</span>
            <i *ngIf="showProductLineDetail || showProductDetail" class="fas fa-angle-right"></i>
          </li>
          <li *ngIf="showProductLineDetail || showProductDetail" [ngClass]="showProductLineDetail == true ? 'breadcrumb-item active' : 'breadcrumb-item'">
            <a *ngIf="showProductLineDetail == false" href="javascript:void(0)" (click)="revertToIsProductLineSearch()">{{marketingBrand }}</a>
            <span *ngIf="showProductLineDetail == true">{{marketingBrand }}</span>
            <i class="fas fa-angle-right" *ngIf="showProductDetail"></i>
          </li>
          <li class="breadcrumb-item active" *ngIf="showProductDetail">{{productName}}</li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="row">

    <div class="col-md-12">

      <div class="fulfill-top-sec">
        <div class="row listing-action-items">
          <div class="col-xl-4 col-lg-4 col-md-4">
          </div>
          <div class="col-xl-8 col-lg-8 col-md-8 text-right">
            <mat-paginator *ngIf="isProductSearch || showProductLineDetail" #productPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
            <mat-paginator *ngIf="showProductDetail" [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="onPaginatorChange($event)"></mat-paginator>
          </div>
        </div>
      </div>

      <div class="tableContainer orderSummaryTable" *ngIf="isProductSearch">
        <table #productSearchTable mat-table [dataSource]="totalOrderSummaryDataSource" matSort matSortDirection="desc" multiTemplateDataRows class="matTables productSearchTable resultTable">

          <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
            <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="productLineName">Product Line</th>
      </div>
      <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef class="productName text-center">Marketing Brand</th></div>
      <div *ngIf="column=='growerUnits'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Grower Units</th></div>
      <div *ngIf="column=='myDealerBucketQty'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">My Dealer Bucket</th></div>
      <div *ngIf="column=='totalGrowerUnit'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Total Grower Units</th></div>
      <div *ngIf="column=='longShort'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Long/(Short)</th></div>
      <div *ngIf="column=='dealerUnits'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Dealer Units</th></div>
      <div *ngIf="column=='shippable'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Total Ordered Units</th></div>
      <div *ngIf="column=='shippedInvoicedQty'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Shipped/Invoiced</th></div>
      <div *ngIf="column=='inProgressQty'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">In Progress</th></div>
      <div *ngIf="column=='leftToProcess'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Balance</th></div>
      <div *ngIf="column=='pY_GPOS'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">PY GPOS</th></div>
      <td mat-cell *matCellDef="let element">

        <div *ngIf="column=='productLine'" class="unitsText text-center">
          <div *ngIf="!element.isGroupBy">
            {{element.productLine }}
          </div>
          <div *ngIf="element.isGroupBy">
            Sub Total:
          </div>
        </div>
        <div *ngIf="column=='marketingBrand'" class="text-center">
          <div *ngIf="!element.isGroupBy">
            <a href="javascript:void(0)" (click)="changeToSearchByProduct(element)">{{element.marketingBrand }}</a>
          </div>
        </div>
        <div *ngIf="column=='growerUnits'" class="text-center">
          <div>
            {{commonService.getFormatedNumber(element.growerUnits) | number}}
          </div>
        </div>
        <div *ngIf="column=='totalGrowerUnit'" class="text-center">
          <div>
            {{commonService.getFormatedNumber(element.totalGrowerUnit) | number}}
          </div>
        </div>
        <div *ngIf="column=='myDealerBucketQty'" class="text-center">
          <div>
            {{element.myDealerBucketQty | number}}
          </div>
        </div>
        <div *ngIf="column=='longShort'" class="text-center">
          <div class="oval-shape treatment" *ngIf="element.longShort < 0">
            ({{ element?.longShort | positiveValue | number }})
          </div>
          <div *ngIf="element.longShort >= 0">
            {{ element?.longShort | number }}
          </div>
        </div>
        <div *ngIf="column=='dealerUnits'" class="text-center">
          <div>
            {{element.dealerUnits | number}}
          </div>
        </div>
        <div *ngIf="column=='shippable'" class="text-center">
          <div>
            {{element.shippable | number}}
          </div>
        </div>
        <div *ngIf="column=='shippedInvoicedQty'" class="text-center">
          <div>
            {{element.shippedInvoicedQty | number}}
          </div>
        </div>
        <div *ngIf="column=='inProgressQty'" class="text-center">
          <div>
            {{element.inProgressQty | number}}
          </div>
        </div>
        <div *ngIf="column=='leftToProcess'" class="text-center">
          <div>
            {{element.leftToProcess | number}}
          </div>
        </div>
        <div *ngIf="column=='pY_GPOS'" class="text-center">
          <div *ngIf="element.pY_GPOS < 0">
            ({{ element?.pY_GPOS |positiveValue| number }})
          </div>
          <div *ngIf="element.pY_GPOS >= 0">
            {{ element?.pY_GPOS | number }}
          </div>
        </div>
      </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky:true;"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row" [ngClass]="element.isGroupBy ? 'subTotalRow' : ''"></tr>
      </table>

      <div *ngIf="totalOrderSummaryDataSource == undefined || totalOrderSummaryDataSource?.data.length == 0" class="noDataMsg">
        <p>No Record Found.</p>
      </div>
    </div>

    <div class="tableContainer marketingBrandTable" *ngIf="showProductLineDetail">
      <div>
        <table #showProductLineTable mat-table [dataSource]="productTotalOrderSummaryDataSource" matSort matSortDirection="desc" multiTemplateDataRows class="matTables showProductLineTable resultTable">

          <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
            <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="productLineName">Product Line</th>
      </div>
      <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef class="productName text-center">Product Name</th></div>
      <div *ngIf="column=='growerUnits'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Grower Units</th></div>
      <div *ngIf="column=='myDealerBucketQty'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">My Dealer Bucket</th></div>
      <div *ngIf="column=='totalGrowerUnit'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Total Grower Units</th></div>
      <div *ngIf="column=='longShort'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Long/(Short)</th></div>
      <div *ngIf="column=='dealerUnits'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Dealer Units</th></div>
      <div *ngIf="column=='shippable'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Total Ordered Units</th></div>
      <div *ngIf="column=='shippedInvoicedQty'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Shipped/Invoiced</th></div>
      <div *ngIf="column=='inProgressQty'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">In Progress</th></div>
      <div *ngIf="column=='leftToProcess'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">Balance</th></div>
      <div *ngIf="column=='pY_GPOS'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="productName text-center">PY GPOS</th></div>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="column=='productLine'" class="unitsText">
          <div *ngIf="!element.isGroupBy">
            {{element.productLine }}
          </div>
          <div *ngIf="element.isGroupBy">
            Sub Total:
          </div>
        </div>
        <div *ngIf="column=='marketingBrand'" class="text-center">
          <div *ngIf="!element.isGroupBy">
            <a href="javascript:void(0)" (click)="changeToProductDetail(element)">{{element.brand }}</a>
          </div>
        </div>
        <div *ngIf="column=='growerUnits'" class="text-center">
          <div>
            {{commonService.getFormatedNumber(element.growerUnits) | number}}
          </div>
        </div>
        <div *ngIf="column=='myDealerBucketQty'" class="text-center">
          <div>
            {{commonService.getFormatedNumber(element.myDealerBucketQty) | number}}
          </div>
        </div>
        <div *ngIf="column=='totalGrowerUnit'" class="text-center">
          <div>
            {{commonService.getFormatedNumber(element.totalGrowerUnit) | number}}
          </div>
        </div>
        <div *ngIf="column=='longShort'" class="text-center">
          <div *ngIf="element.longShort < 0" class="oval-shape treatment">
            ({{ commonService.getFormatedNumber(element?.longShort | positiveValue) | number}})
          </div>
          <div *ngIf="element.longShort >= 0">
            {{ commonService.getFormatedNumber(element?.longShort) | number}}
          </div>
        </div>
        <div *ngIf="column=='dealerUnits'" class="text-center">
          <div>
            {{element.dealerUnits | number}}
          </div>
        </div>
        <div *ngIf="column=='shippable'" class="text-center">
          <div>
            {{element.shippable | number}}
          </div>
        </div>
        <div *ngIf="column=='shippedInvoicedQty'" class="text-center">
          <div>
            {{element.shippedInvoicedQty | number}}
          </div>
        </div>
        <div *ngIf="column=='inProgressQty'" class="text-center">
          <div>
            {{element.inProgressQty | number}}
          </div>
        </div>
        <div *ngIf="column=='leftToProcess'" class="text-center">
          <div>
            {{element.leftToProcess | number}}
          </div>
        </div>
        <div *ngIf="column=='pY_GPOS'" class="text-center">
          <div *ngIf="element.pY_GPOS < 0">
            ({{ element?.pY_GPOS | positiveValue | number }})
          </div>
          <div *ngIf="element.pY_GPOS >= 0">
            {{ element?.pY_GPOS | number }}
          </div>
        </div>
      </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky:true;"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row" [ngClass]="element.isGroupBy ? 'subTotalRow' : ''"></tr>
      </table>

      <div *ngIf="productTotalOrderSummaryDataSource == undefined || productTotalOrderSummaryDataSource?.data.length == 0" class="noDataMsg">
        <p>No Record Found.</p>
      </div>
    </div>
  </div>

  <div class="ordersTableOuter">
    <div class="tableContainer " *ngIf="showProductDetail">
      <div class="tableComponentOuter ordersTable ">
        <table class="matTables tableComponentInner mat-table" matSort (matSortChange)="sortData($event)">
          <thead>
            <tr class="mat-header-row">
              <th [class]="header?.className" *ngFor="let header of headerDS" [mat-sort-header]="header?.columnfield">
                <div>
                  {{header.headertxt}}
                </div>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="paginatorDS.length != 0">
            <tr class="mat-row" *ngFor="let row of paginatorDS">
              <td class="mat-cell" *ngFor="let col of headerDS" [class]="col?.tdClassName">
                <div [ngSwitch]="col.columnfield">
                  <div *ngSwitchCase="'orderNumber'" (click)="redirectToOrder($event,row)">
                    <span [ngClass]="{'handCursor' : row.clickable,'text-decoration-underline' : row.clickable}">{{row.orderNumber}}</span>
                    <span *ngIf="row.b2B" class="erp-order"><i title="B2B" class="fas fa-lock"></i></span>
                  </div>
                  <div *ngSwitchCase="'productName'">
                    <p class="grower-name">
                      {{row.brand}}
                    </p>
                  </div>
                  <div *ngSwitchCase="'itemDescription'">
                    <!--<p>{{row.brand}} - {{row.marketingBrand}}</p>-->
                    <p class="grower-name">
                      {{row.itemDescription}}
                    </p>
                  </div>
                  <div *ngSwitchCase="'quantity'">
                    <div *ngIf="row.orderType =='Dealer Order'">
                      {{ row?.dealerUnits | number }}
                    </div>
                    <div *ngIf="row.orderType =='Grower Order'">
                      {{ row?.growerUnits | number }}
                    </div>
                  </div>
                  <div *ngSwitchCase="'inProgressQty'">
                    {{ row?.inProgressQty | number }}
                  </div>
                  <div *ngSwitchCase="'shippedInvoicedQty'">
                    {{ row?.shippedInvoicedQty | number }}
                  </div>
                  <div *ngSwitchCase="'desiredDeliveryDate'">
                    {{ row?.desiredDeliveryDate | date:'MM/dd/yyyy'}}
                  </div>
                  <div *ngSwitchCase="'leftToProcess'">
                    {{ row?.leftToProcess | number }}
                  </div>
                  <div *ngSwitchCase="'leftToInvoiced'">
                    {{ row?.leftToInvoiced | number }}
                  </div>
                  <div *ngSwitchCase="'longShort'">
                    <div *ngIf="row.longShort < 0" class="oval-shape treatment">
                      ({{ row?.longShort |positiveValue| number }})
                    </div>
                    <div *ngIf="row.longShort >= 0">
                      {{ row?.longShort | number }}
                    </div>
                  </div>
                  <div *ngSwitchCase="'pY_GPOS'">
                    <div *ngIf="row.pY_GPOS < 0">
                      ({{ row?.pY_GPOS |positiveValue| number }})
                    </div>
                    <div *ngIf="row.pY_GPOS >= 0">
                      {{ row?.pY_GPOS | number }}
                    </div>
                  </div>
                  <div *ngSwitchCase="'myDealerBucketQty'">
                    {{ row?.myDealerBucketQty | number }}
                  </div>
                  <div *ngSwitchCase="'implementationSpecialist'">
                    {{ row?.implAccountName }}
                  </div>
                  <div *ngSwitchCase="'accountManager'">
                    {{ row?.actMgrAccountName }}
                  </div>
                  <div *ngSwitchCase="'salesEnablement'">
                    {{ row?.salesEnabAccountName }}
                  </div>
                  <div *ngSwitchCase="'buLead'">
                    {{ row?.asmLeadAccountName }}
                  </div>
                  <div *ngSwitchCase="'cdsLead'">
                    {{ row?.secdsLeadAccountName }}
                  </div>
                  <div *ngSwitchDefault>
                    {{row[col?.columnfield]}}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="paginatorDS.length == 0">
            <tr>
              <td class="mat-cell" colspan="7" valign="middle">
                <div class="noRecordMsg">
                  No record Found.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
